








































import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class OptionSurvey extends Vue {
  @Prop() readonly title!: string;
  @Prop() readonly optionOne!: string;
  @Prop() readonly optionTwo!: string;
  @Prop() readonly optionThree!: string;

  admission() {
    this.$emit("admission");
  }

  discharge() {
    this.$emit("discharge");
  }

  satisfaction() {
    this.$emit("satisfaction");
  }

  close() {
    this.$emit("close");
  }
}
